'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Filter = require('./Filter');

var _Filter2 = _interopRequireDefault(_Filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Head = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Head, _React$Component);

  function Head() {
    (0, _classCallCheck3.default)(this, Head);
    return (0, _possibleConstructorReturn3.default)(this, (Head.__proto__ || Object.getPrototypeOf(Head)).apply(this, arguments));
  }

  (0, _createClass3.default)(Head, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'paginated-head' },
        _react2.default.createElement(
          'div',
          { className: 'paginated-head-container' },
          _react2.default.createElement(
            'div',
            { className: 'paginated-head-left' },
            this.props.leftComponent ? _react2.default.createElement(this.props.leftComponent, { variables: this.props.variables, setVariable: this.props.setVariable }) : _react2.default.createElement(
              'div',
              { className: 'paginated-head-title' },
              this.props.title
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'paginated-head-center' },
            _react2.default.createElement(this.props.centerComponent, { variables: this.props.variables, setVariable: this.props.setVariable })
          ),
          _react2.default.createElement(
            'div',
            { className: 'paginated-head-right' },
            this.props.rightComponent ? _react2.default.createElement(this.props.rightComponent, { variables: this.props.variables, setVariable: this.props.setVariable }) : _react2.default.createElement(_Filter2.default, { variables: this.props.variables, setVariable: this.props.setVariable })
          )
        ),
        _react2.default.createElement(this.props.bottomComponent, { variables: this.props.variables, setVariable: this.props.setVariable })
      );
    }
  }]);
  return Head;
}(_react2.default.Component), _class.propTypes = {
  bottomComponent: _react2.default.PropTypes.func,
  rightComponent: _react2.default.PropTypes.func,
  leftComponent: _react2.default.PropTypes.func,
  title: _react2.default.PropTypes.any,
  centerComponent: _react2.default.PropTypes.func.isRequired,
  variables: _react2.default.PropTypes.object,
  setVariable: _react2.default.PropTypes.func.isRequired
}, _temp);
exports.default = Head;


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-paginated-graphql-react/lib/Head/index.js
// module id = 2679
// module chunks = 0